export const superAdminItems = ['Update Commitment/Allocation Calculations', 'Update Aggregate Commitment', 'Update Aggregate Interest'];
